{
  "version": 1,
  "asset_id": "b44c80bc-9cae-474f-9482-9038158a55f0",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/b44c80bc-9cae-474f-9482-9038158a55f0/stamped-concrete-finished.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/b44c80bc-9cae-474f-9482-9038158a55f0/stamped-concrete-finished.webp",
  "original_filename": "stamped-concrete-finished.webp",
  "size": 171006,
  "content_type": "image/webp",
  "created_at": "2026-09-11T23:07:27Z"
}
